var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      ref: "upload",
      staticClass: "upload-demo",
      attrs: {
        drag: "",
        action: "#",
        "auto-upload": false,
        multiple: _vm.multiple,
        limit: _vm.multiple ? _vm.limit : undefined,
        accept: _vm.accept,
        disabled: _vm.disabled,
        "file-list": _vm.fileList,
        "on-change": _vm.handleChange,
        "on-remove": _vm.handleRemove,
        "on-exceed": _vm.handleExceed,
        "on-preview": _vm.handlePreview
      }
    },
    [
      _c("i", { staticClass: "el-icon-upload" }),
      _vm._v(" "),
      _c("div", { staticClass: "el-upload__text" }, [
        _vm._v("\n        Arraste e solte o arquivo aqui ou "),
        _c("em", [_vm._v("clique para enviar")])
      ]),
      _vm._v(" "),
      _vm.tipText
        ? _c(
            "div",
            {
              staticClass: "el-upload__tip",
              attrs: { slot: "tip" },
              slot: "tip"
            },
            [_vm._v(_vm._s(_vm.tipText))]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0194dbb9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0194dbb9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_micro/Form/upload/FormDragAndDropUpload.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0194dbb9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_micro/Form/upload/FormDragAndDropUpload.vue
// module chunks = 2